/**
 * The Auth Gateway is a service of its own. It usually sits next to the scoring
 * backend behind the same host (`…/auth` alongside `…/zadmin`), but nothing
 * guarantees that — it is deployed separately and may move to its own host, so
 * it gets its own environment variable.
 *
 * Deriving from the scoring URL is only the fallback that keeps a deployment
 * that configures a single URL working, both on the current layout and on the
 * legacy one where auth lived under `…/auth` of the scoring base.
 */
export const deriveAuthUrl = (apiBaseUrl: string): string =>
	`${(apiBaseUrl ?? "").replace(/\/+$/, "").replace(/\/zadmin$/, "")}/auth`;

/**
 * Resolves the Auth Gateway base URL from the configured candidates, most
 * specific first: the runtime value injected into `window._env_` at container
 * start, then the value baked in at build time, then the scoring URL it is
 * derived from. Blank values are treated as unset — the Docker image seeds
 * every key in `env-config.js`, so an unconfigured one arrives as `""`.
 */
export const resolveAuthUrl = (
	candidates: (string | undefined)[],
	apiBaseUrl: string,
): string =>
	candidates.find((candidate) => Boolean(candidate?.trim())) ??
	deriveAuthUrl(apiBaseUrl);
